// extracted by mini-css-extract-plugin
export default {"colorsContainer":"Tbug04"};